import React from "react";
import styled from "styled-components";
import api from "../../../../util/api";
import { toast } from "react-toastify";

const MAX_BYTES = 25 * 1024 * 1024;
const ALLOWED_EXT = ["pdf","jpg","jpeg","png","gif","mp3","wav","m4a","mp4","mov","doc","docx"];

const Overlay = styled.div`
    display: ${(p) => (p.open ? "flex" : "none")};
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.4); z-index: 1000;
    align-items: center; justify-content: center;
`;
const Modal = styled.div`
    background: white; width: 460px; max-width: 90%;
    padding: 24px; border-radius: 8px;
`;
const Heading = styled.h2`font-size: 22px; margin: 0 0 16px;`;
const Label = styled.label`display: block; font-weight: 600; margin-top: 12px;`;
const Input = styled.input`
    width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;
    margin-top: 4px;
`;
const Hint = styled.div`color: #737697; font-size: 12px; margin-top: 4px;`;
const ErrorText = styled.div`color: #b00; font-size: 13px; margin-top: 6px;`;
const CheckRow = styled.label`display: block; margin-top: 6px; font-weight: 400;`;
const Actions = styled.div`margin-top: 24px; display: flex; justify-content: flex-end; gap: 12px;`;
const Btn = styled.button`
    padding: 8px 16px; border: none; border-radius: 4px; cursor: pointer;
    background: ${(p) => (p.primary ? "#5562C0" : "#eee")};
    color: ${(p) => (p.primary ? "white" : "#333")};
`;

export default class StudentFileUploadModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            name: "",
            file: null,
            selectedInstructorIds: [],
            errors: {},
            submitting: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            this.setState(this.initialState());
        }
    }

    toggleInstructor(id) {
        this.setState((prev) => {
            const has = prev.selectedInstructorIds.includes(id);
            return {
                selectedInstructorIds: has
                    ? prev.selectedInstructorIds.filter((x) => x !== id)
                    : [...prev.selectedInstructorIds, id],
            };
        });
    }

    handleFile(e) {
        const f = e.target.files[0] || null;
        const errors = { ...this.state.errors };
        delete errors.file;
        if (f) {
            const ext = (f.name.split(".").pop() || "").toLowerCase();
            if (f.size > MAX_BYTES) errors.file = "File is larger than 25 MB.";
            else if (!ALLOWED_EXT.includes(ext)) errors.file = `Type .${ext} is not allowed.`;
        }
        this.setState({ file: f, errors });
    }

    submit() {
        const errors = {};
        if (!this.state.name.trim()) errors.name = "Name is required.";
        if (!this.state.file) errors.file = errors.file || "Choose a file.";
        if (Object.keys(errors).length) { this.setState({ errors }); return; }

        const data = new FormData();
        data.append("name", this.state.name.trim());
        data.append("file", this.state.file);
        if (this.state.selectedInstructorIds.length) {
            data.append("extra_user_ids", this.state.selectedInstructorIds.join(","));
        }

        this.setState({ submitting: true });
        api().post("files", data)
            .then(() => {
                toast.success("File uploaded.", { position: "top-right", autoClose: 5000, hideProgressBar: true });
                this.setState({ submitting: false });
                this.props.onUploaded && this.props.onUploaded();
                this.props.onClose();
            })
            .catch((err) => {
                const fieldErrors = err?.response?.data?.errors || {};
                const flat = {};
                Object.keys(fieldErrors).forEach((k) => { flat[k] = fieldErrors[k][0]; });
                this.setState({ submitting: false, errors: flat });
                if (!Object.keys(flat).length) {
                    toast.error("Couldn't upload, please try again.", { position: "top-right", autoClose: 5000 });
                }
            });
    }

    render() {
        const { open, onClose, instructors = [] } = this.props;
        const { name, errors, submitting, selectedInstructorIds } = this.state;

        return (
            <Overlay open={open} onClick={onClose}>
                <Modal onClick={(e) => e.stopPropagation()}>
                    <Heading>Add File</Heading>

                    <Label>Name *</Label>
                    <Input
                        type="text"
                        value={name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                    />
                    {errors.name && <ErrorText>{errors.name}</ErrorText>}

                    <Label>File *</Label>
                    <Input
                        type="file"
                        className="file-input"
                        onChange={(e) => this.handleFile(e)}
                    />
                    <Hint>Up to 25 MB. PDF, images, audio, video, or docs.</Hint>
                    {errors.file && <ErrorText>{errors.file}</ErrorText>}

                    <Label>Share with (optional)</Label>
                    {instructors.length === 0 ? (
                        <Hint>You'll be able to share files once you have an instructor.</Hint>
                    ) : (
                        instructors.map((inst) => (
                            <CheckRow key={inst.id}>
                                <input
                                    type="checkbox"
                                    checked={selectedInstructorIds.includes(inst.id)}
                                    onChange={() => this.toggleInstructor(inst.id)}
                                />
                                {" "}{inst.name}
                            </CheckRow>
                        ))
                    )}

                    <Actions>
                        <Btn onClick={onClose} disabled={submitting}>Cancel</Btn>
                        <Btn primary onClick={() => this.submit()} disabled={submitting}>
                            {submitting ? "Uploading…" : "Upload"}
                        </Btn>
                    </Actions>
                </Modal>
            </Overlay>
        );
    }
}
